<template>
    <v-container transparent>
        <v-layout>
            <v-card flat style="max-width: 1300px">
                <v-card-title class="pa-4 title">Базовая анкета</v-card-title>


                <v-form v-model="formValid" ref="profile_form">
                    <v-container grid-list-sm class="pa-2">
                        <v-layout>
                            <v-flex offset-lg2 lg8 xs12 class="pb-5" style="text-align: center">
                                Для предоставления более объективной информации рекомендуется правдиво и точно
                                ответить на предлагаемые вопросы нашей анкеты. Все сведения, которые
                                Вы предоставляете, останутся строго конфиденциальными.<br>
                                Все поля в данной форме обязательны для заполнения
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>

                            <v-stepper v-model="utility.step" non-linear vertical flat>

                                <v-stepper-step :complete="utility.step > 1" step="1" editable>
                                    Измерения
                                    <small>и семейное положение</small>
                                </v-stepper-step>

                                <v-stepper-content step="1">

                                    <v-layout wrap>

                                        <v-flex offset-lg1 lg5 md12 xs12 class="px-2">
                                            <v-layout wrap>
                                                <v-flex lg12 md4 xs12 class="px-3">
                                                    <v-select prepend-icon="person" name="sex" label="Ваш пол" class="notranslate"
                                                              v-model="agendaData.sex" :items="utility.sexes"
                                                              :rules="[rules.required]"></v-select>
                                                </v-flex>

                                                <v-flex lg12 md4 xs12 class="px-3">
                                                    <v-select prepend-icon="person" name="marital_status" class="notranslate"
                                                              label="Семейное положение"
                                                              v-model="agendaData.marital_status"
                                                              :items="utility.marital_statuses"
                                                              :rules="[rules.required]"></v-select>
                                                </v-flex>

                                                <v-flex lg12 md4 xs12 class="px-3">
                                                    <v-select prepend-icon="person" name="children" label="Дети" class="notranslate"
                                                              v-model="agendaData.children" :items="utility.children"
                                                              :rules="[rules.required]"></v-select>

                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex offset-lg1 lg4 md12 xs12 class="px-2">
                                            <v-layout wrap>
                                                <v-flex lg12 md4 xs12 class="px-3">
                                                    <v-text-field prepend-icon="person" name="age" class="notranslate"
                                                                  label="Кол-во полных лет"
                                                                  type="text"
                                                                  v-model="agendaData.age"
                                                                  :rules="[rules.required]"></v-text-field>
                                                </v-flex>

                                                <v-flex lg12 md4 xs12 class="px-3">
                                                    <v-text-field prepend-icon="person" name="height" class="notranslate"
                                                                  label="Ваш рост (см)"
                                                                  type="text"
                                                                  v-model="agendaData.height"
                                                                  :rules="[rules.required]"></v-text-field>
                                                </v-flex>

                                                <v-flex lg12 md4 xs12 class="px-3">
                                                    <v-text-field prepend-icon="person" name="weight" class="notranslate"
                                                                  label="Ваш вес (кг)"
                                                                  type="text"
                                                                  v-model="agendaData.weight"
                                                                  :rules="[rules.required]"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex offset-lg1 lg11 md12 xs12 class="pa-3">
                                            <v-btn color="primary" @click="utility.step = 2">Продолжить</v-btn>
                                        </v-flex>

                                    </v-layout>
                                </v-stepper-content>


                                <v-stepper-step :complete="utility.step > 2" step="2" editable>
                                    Место рождения
                                    <small>происхождение и национальность</small>
                                </v-stepper-step>

                                <v-stepper-content step="2">
                                    <v-layout wrap>

                                        <v-flex offset-lg1 lg4 md12 xs12 class="px-2">
                                            <v-layout wrap>

                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-autocomplete name="birth_country" label="Место рождения - страна"
                                                                    :loading="utility.countryListLoading"
                                                                    :items="utility.countryList"
                                                                    item-text="name"

                                                                    return-object
                                                                    :search-input.sync="searchCountry"
                                                                    flat
                                                                    hide-no-data
                                                                    browser-autocomplete="true"
                                                                  prepend-icon="location_on"
                                                                    class="notranslate"
                                                                  :rules="[rules.required]" required

                                                                  v-model="agendaData.birth_country"></v-autocomplete>
                                                </v-flex>
                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-autocomplete name="birth_city" label="Место рождения - город"
                                                                    :loading="utility.cityListLoading"
                                                                    :items="utility.cityList"
                                                                    item-text="alternateName"
                                                                    return-object
                                                                    :search-input.sync="searchCity"
                                                                    flat
                                                                    cache-items
                                                                    hide-no-data
                                                                    browser-autocomplete="true"
                                                                    prepend-icon="location_city"
                                                                    class="notranslate"
                                                                    :disabled="!agendaData.birth_country"
                                                                    :rules="[rules.required]" required
                                                                    v-model="agendaData.birth_city"></v-autocomplete>

                                                </v-flex>

                                            </v-layout>
                                        </v-flex>

                                        <v-flex offset-lg1 lg5 md12 xs12 class="px-2">
                                            <v-layout wrap>
                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-select prepend-icon="person" name="ethnos" class="notranslate"
                                                              label="Раса/этническая группа"
                                                              v-model="agendaData.ethnos" :items="utility.ethnoses"
                                                              :rules="[rules.required]"></v-select>
                                                </v-flex>
                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-autocomplete name="birth_country" label="Национальность: выбрать/ указать “не знаю“"
                                                                    :items="utility.nationalities"
                                                                    flat
                                                                    hide-no-data
                                                                    browser-autocomplete="true"
                                                                    prepend-icon="person"
                                                                    class="notranslate"
                                                                    :rules="[rules.required]" required
                                                                    v-model="agendaData.nationality"></v-autocomplete>

                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex offset-lg1 lg11 md12 xs12 class="pa-3">
                                            <v-btn @click="utility.step = 1" flat>Назад</v-btn>
                                            <v-btn color="primary" @click="utility.step = 3">Продолжить</v-btn>
                                        </v-flex>

                                    </v-layout>
                                </v-stepper-content>


                                <v-stepper-step :complete="utility.step > 3" step="3" editable>
                                    Медицинские обследования
                                    <small>и оценка здоровья</small>
                                </v-stepper-step>

                                <v-stepper-content step="3">
                                    <v-layout wrap>

                                        <v-flex offset-lg1 offset-md0 lg4 md12 xs12 class="px-0">
                                            <v-layout wrap>
                                                <v-flex lg12 md12 xs12 class="px-3">
                                                    <div class="c-sub-title">Как часто Вы проходите медицинское обследование? (очень редко, один раз в год, чаще чем в раз в год)</div>
                                                    <v-select prepend-icon="person" name="screening_period" class="notranslate"
                                                              label="Периодичность медицинскох обследований"
                                                              v-model="agendaData.screening_period"
                                                              :items="utility.screening_periods"
                                                              :rules="[rules.required]"></v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex offset-lg1 lg4 md12 xs12 class="px-0">
                                            <v-layout wrap>
                                                <v-flex lg12 md12 xs12 class="px-3">
                                                    <div class="c-sub-title">Как Вы сами оцениваете свое здоровье (по шкале от 1 до 10, 1 - плохое, 10 - очень хорошее)</div>
                                                    <v-text-field prepend-icon="person" name="self_health_estimate" class="notranslate"
                                                                  label="Оцените свое здоровье"
                                                                  type="text"
                                                                  v-model="agendaData.self_health_estimate"
                                                                  :rules="[rules.required]"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex offset-lg1 lg11 md12 xs12 class="pa-3">
                                            <v-btn @click="utility.step = 2" flat>Назад</v-btn>
                                            <v-btn color="primary" @click="utility.step = 4">Продолжить</v-btn>
                                        </v-flex>

                                    </v-layout>
                                </v-stepper-content>


                                <v-stepper-step :complete="utility.step > 4" step="4" editable>
                                    Общие данные
                                    <small>Общие данные</small>
                                </v-stepper-step>

                                <v-stepper-content step="4">
                                    <v-layout wrap>
                                        <v-flex xs12 class="pb-5" style="text-align: center">
                                            Обнаруживались ли у Вас следующие состояния?
                                        </v-flex>

                                        <v-flex offset-lg1 lg5 md12 xs12 class="px-2">

                                            <v-layout wrap>
                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-switch name="high_cholesterol"
                                                              label="Повышенный уровень холестерина в крови"
                                                              v-model="agendaData.conditions.high_cholesterol"
                                                    ></v-switch>
                                                </v-flex>

                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-switch name="high_blood_pressure"
                                                              label="Высокое артериальное давление"
                                                              v-model="agendaData.conditions.high_blood_pressure"
                                                    ></v-switch>
                                                </v-flex>

                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-switch name="heart_rhythm_disturbance"
                                                              label="Нарушение сердечного ритма или работы сердца"
                                                              v-model="agendaData.conditions.heart_rhythm_disturbance"
                                                    ></v-switch>
                                                </v-flex>

                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-switch name="high_heart_rate"
                                                              label="Увеличенная частота сердечных сокращений в покое"
                                                              v-model="agendaData.conditions.high_heart_rate"
                                                    ></v-switch>
                                                </v-flex>

                                            </v-layout>
                                        </v-flex>

                                        <v-flex offset-lg1 lg5 md12 xs12 class="px-2">
                                            <v-layout wrap>
                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-switch name="increased_glucose_levels"
                                                              label="Повышенный уровень глюкозы в крови"
                                                              v-model="agendaData.conditions.increased_glucose_levels"
                                                    ></v-switch>
                                                </v-flex>

                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-switch name="excess_body_weight" label="Избыточная масса тела"
                                                              v-model="agendaData.conditions.excess_body_weight"
                                                    ></v-switch>
                                                </v-flex>

                                                <v-flex lg12 md6 xs12 class="px-3">
                                                    <v-switch name="low_body_weight" label="Недостаточная масса тела"
                                                              v-model="agendaData.conditions.low_body_weight"
                                                    ></v-switch>
                                                </v-flex>

                                            </v-layout>
                                        </v-flex>
                                        <v-flex offset-lg1 lg11 md12 xs12 class="pa-3">
                                            <v-btn @click="utility.step = 3" flat>Назад</v-btn>
                                            <v-btn color="primary" flat @click="utility.step = 1">Вернуться к 1 шагу</v-btn>
                                        </v-flex>

                                    </v-layout>
                                </v-stepper-content>

                            </v-stepper>

                        </v-layout>
                    </v-container>
                </v-form>
                <v-card-actions class="px-5">

                    <v-spacer></v-spacer>
                    <v-btn large color="primary" :disabled="!formCanSave" @click="updateAgenda()">Сохранить
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    //import deepEqual from 'deep-equal'
    //import assert from 'assert'


    // Обнаруживались ли у Вас следующие состояния?

    // Повышенный уровень холестерина в крови
    // Высокое артериальное давление
    // Нарушение сердечного ритма или работы сердца
    // Увеличенная частота сердечных сокращений в покое

    // Повышенный уровень  глюкозы в крови
    // Избыточная масса тела
    // Недостаточная масса тела


    function jsonEqual(a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    export default {
        lang: '',
        name: "BasicAgenda",
        data: () => ({
            formValid: false,

            agendaDataInitial: {
                sex: '',
                height: '',
                weight: '',
                age: "",
                marital_status: "",
                children: null,
                birth_country: "",
                birth_city: "",
                self_health_estimate: 1,
                screening_period: "", // 0-1-2 (очень редко, один раз в год, чаще чем в раз в год)
                ethnos: "", //  европейская (европеоид), африканская (негроид), азиатская (монголоид), латиноамериканская, евреи-ашкенази
                nationality: "",
                conditions: {
                    high_cholesterol: false,
                    high_blood_pressure: false,
                    heart_rhythm_disturbance: false,
                    high_heart_rate: false,
                    increased_glucose_levels: false,
                    excess_body_weight: false,
                    low_body_weight: false
                }
            },

            agendaData: {
                sex: '',
                height: '',
                weight: '',
                age: "",
                marital_status: "",
                children: null,
                birth_country: "",
                birth_city: "",
                self_health_estimate: 1,
                screening_period: "", // 0-1-2 (очень редко, один раз в год, чаще чем в раз в год)
                ethnos: "", //  европейская (европеоид), африканская (негроид), азиатская (монголоид), латиноамериканская, евреи-ашкенази
                nationality: "",
                conditions: {
                    high_cholesterol: false,
                    high_blood_pressure: false,
                    heart_rhythm_disturbance: false,
                    high_heart_rate: false,
                    increased_glucose_levels: false,
                    excess_body_weight: false,
                    low_body_weight: false
                }
            },

            utility: {
                step: 1,
                birthday: false,
                children: ["Нет", "Есть"],
                sexes: ["Мужской", "Женский"],
                ethnoses2: ["европейская (европеоид)", "африканская (негроид)", "азиатская (монголоид)", "латиноамериканская", "евреи-ашкенази"],
                ethnoses: ["европейская (европеоид)", "африканская (негроид)", "азиатская (монголоид)"],
                marital_statuses: ["женат/замужем", "холост"],
                screening_periods: ["очень редко", "один раз в год", "чаще чем в раз в год"],
                self_health_estimates: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                nationalities: [
                    "Не знаю",
                    "абадзехи",
                    "абаза",
                    "абазины",
                    "абжуйцы",
                    "абхазы",
                    "аварал",
                    "аварцы",
                    "австрийцы",
                    "агинцы",
                    "агул шуй",
                    "агулар",
                    "агульцы",
                    "агулы",
                    "адай",
                    "аджарели",
                    "аджарцы",
                    "адыгейцы",
                    "адыгэ (с родным языком адыгейским)",
                    "адыгэ (с родным языком кабардинским)",
                    "адыгэ (с родным языком черкесским)",
                    "азербайджанлы",
                    "азербайджанлылар",
                    "азербайджанцы",
                    "айсоры",
                    "аккинцы",
                    "алабугатские татары",
                    "алаи",
                    "албанцы",
                    "алеуты",
                    "алжирцы",
                    "алтай-кижи",
                    "алтайцы",
                    "алтына куманды",
                    "алутальу",
                    "алюторцы",
                    "амгун бэйенин",
                    "американцы",
                    "анатри",
                    "ангагинас",
                    "англичане",
                    "андал",
                    "андии",
                    "андийцы",
                    "анкалгакку",
                    "анкалын",
                    "анкальын",
                    "апокваямыл",
                    "апсуа",
                    "апукинцы",
                    "араби",
                    "арабы",
                    "арабы ОАЭ",
                    "арабы среднеазиатские",
                    "аравийцы",
                    "арамеи",
                    "аргын",
                    "армяне",
                    "армяне донские",
                    "армяне крымские",
                    "арнауты",
                    "арчи",
                    "арчиб",
                    "арчинцы",
                    "аршиштиб",
                    "асори",
                    "ассирийцы",
                    "ассурайя",
                    "астраханские татары",
                    "атали ",
                    "атурая ",
                    "аукштайты",
                    "ауховцы",
                    "афганцы",
                    "ахвалал",
                    "ахвахцы",
                    "ахтинцы",
                    "ашвалъ",
                    "ашватл",
                    "ашкеназ",
                    "ашхаруа ",
                    "ашхарцы",
                    "багвалалы",
                    "багвалинцы",
                    "багулав",
                    "багулалы",
                    "баджавидж",
                    "баджуведж",
                    "баджувцы",
                    "баджуйцы",
                    "балкарцы",
                    "балуч",
                    "бани исроил",
                    "бараба",
                    "барабинцы",
                    "баряат",
                    "бахрейнцы",
                    "башкиры",
                    "башкиры-тептяри",
                    "башкорт",
                    "башкурт",
                    "бежитинцы",
                    "бежтинцы",
                    "беларусы",
                    "белорусы",
                    "белуджи",
                    "бенгали",
                    "бенгальцы",
                    "бепся",
                    "берш",
                    "бесермяне",
                    "бесленеевцы (с родным языком адыгейским)",
                    "бесленеевцы (с родным языком кабардино-черкесским)",
                    "бесленеи",
                    "бешермяне",
                    "бжедуги",
                    "бзыбцы",
                    "бойки",
                    "болгары",
                    "большие дэрбэты",
                    "ботлихцы",
                    "бохарлы",
                    "брещуки ",
                    "бузавы",
                    "буйхади",
                    "буковинцы",
                    "буряад ",
                    "буряты ",
                    "бухарские евреи ",
                    "бухарцы",
                    "ваду",
                    "вадьякко",
                    "вадьялайн",
                    "венгры",
                    "вепсы",
                    "вепся",
                    "верховинцы",
                    "ветлужские марийцы ",
                    "вирьял ",
                    "вогулы ",
                    "водь",
                    "войкыпал'о",
                    "волохь",
                    "восточные (уральские) марийцы ",
                    "вотяки",
                    "воямпольцы",
                    "вудмурт",
                    "вулугуни ",
                    "вутла мари ",
                    "вьет ньгой",
                    "вьетнамцы",
                    "гагаузы",
                    "гай",
                    "галга",
                    "гантляло",
                    "гванал",
                    "гибдиди",
                    "гиляки",
                    "гинухцы",
                    "годоберинцы",
                    "голендры",
                    "голландцы",
                    "гольды",
                    "горные марийцы",
                    "горские евреи",
                    "греки",
                    "греки-ромеи",
                    "греки-урумы",
                    "греки-эллины",
                    "грекос",
                    "грузинские евреи",
                    "грузины",
                    "гунзал",
                    "гунзибцы",
                    "гурбат",
                    "гуцулы",
                    "гьенози",
                    "гъинухъес",
                    "дагестанские евреи",
                    "даг-чуфут",
                    "дарган",
                    "дарганти",
                    "даргинцы",
                    "дейч",
                    "денг",
                    "дербеты",
                    "деткиль",
                    "дживут бухари",
                    "джуги",
                    "джугут",
                    "джуфут",
                    "джухут",
                    "дигор",
                    "дигорон",
                    "дигорцы",
                    "дидойцы",
                    "дойч",
                    "долган",
                    "долганы",
                    "дом",
                    "донские армяне",
                    "дудки",
                    "дулган",
                    "дунгане",
                    "дэрбеты",
                    "дэрбэты",
                    "большие дэрбэты ",
                    "малые дюрбеты ",
                    "дянь",
                    "евреи",
                    "евреи бухарские",
                    "евреи горские",
                    "евреи грузинские",
                    "евреи дагестанские",
                    "евреи крымские",
                    "евреи среднеазиатские",
                    "евреи татские",
                    "египтяне",
                    "езды",
                    "езиды",
                    "ёгэн",
                    "жагайбайлы",
                    "жаппас",
                    "жемайты",
                    "заболотные татары ",
                    "затундренные крестьяне ",
                    "зыряне",
                    "ибдиди",
                    "иври",
                    "идари",
                    "идери",
                    "иди",
                    "иезиды",
                    "ижемцы",
                    "ижора",
                    "ижорцы",
                    "изури",
                    "изьватас",
                    "илийцы",
                    "илкан",
                    "илэ",
                    "имак'лъит",
                    "ингерманландцы",
                    "ингилой",
                    "ингилойцы",
                    "ингрикот",
                    "ингры",
                    "ингуши",
                    "индигирщики",
                    "индийцы хиндиязычные",
                    "инкерилайнен",
                    "инхокваринцы",
                    "иорданцы",
                    "иракцы",
                    "иранцы",
                    "ирон",
                    "иронцы",
                    "испанцы",
                    "исроэл",
                    "итальянцы",
                    "ительмены",
                    "ительмень",
                    "итэнмьи",
                    "иезиды ",
                    "йеменцы ",
                    "йыхбы",
                    "кабардей",
                    "кабардинцы",
                    "кабган",
                    "казанлы",
                    "казанские татары",
                    "казахи",
                    "казахи степские",
                    "казахи туратинские",
                    "кайтаги",
                    "каитагцы",
                    "калмаки",
                    "калмыки",
                    "калпак",
                    "каменцы",
                    "каменщики",
                    "камчадалы (с родным языком ительменским)",
                    "камчадалы (с родным языком русским)",
                    "канинские поморы",
                    "кантага ях",
                    "капучины",
                    "карагасы",
                    "карагасы томские",
                    "карагаши",
                    "карагинцы",
                    "караимы",
                    "карай",
                    "кара-кайтаги",
                    "каракалпаки",
                    "караногайцы",
                    "каран'ыныльо",
                    "каратаи",
                    "каратинцы",
                    "карачаевцы",
                    "карачай",
                    "карачайлыла (карачайлы)",
                    "карелы",
                    "карийские (нукратские) татары",
                    "каролпак",
                    "карпатороссы",
                    "картвели",
                    "карымы",
                    "карьяла",
                    "карьялайзет",
                    "карьялани",
                    "карьяляйн",
                    "касимовские татары",
                    "катарцы",
                    "качинцы",
                    "кашгарцы",
                    "кванадинцы",
                    "кванадлетцы",
                    "кваннал",
                    "кемгуи",
                    "керей ",
                    "кереки",
                    "кержаки",
                    "кето",
                    "кеты",
                    "киргизы",
                    "кирди",
                    "китайцы",
                    "кожла марий",
                    "койбалы",
                    "колымские",
                    "колымчане",
                    "коми (с родным языком коми)",
                    "коми (с родным языком коми-пермяцким)",
                    "коми войтыр",
                    "коми йоз",
                    "коми морт (с родным языком коми)",
                    "коми морт (с родным языком коми-пермяцким)",
                    "коми отир",
                    "коми-ижемцы",
                    "коми-зыряне",
                    "коми-пермяки",
                    "корейцы",
                    "коре сарам",
                    "коряки",
                    "крестьяне затундренные",
                    "крещенцы",
                    "крещеные",
                    "крымские армяне",
                    "крымские евреи",
                    "крымские ногаи",
                    "крымские татары",
                    "крымчаки",
                    "кряшены",
                    "куаннал",
                    "кубанды",
                    "кубачинцы",
                    "кубинцы",
                    "кувейтцы",
                    "кудайраг",
                    "кударцы",
                    "кумандинцы",
                    "куманды",
                    "кумук",
                    "кумыки",
                    "кундровцы",
                    "курд",
                    "курдакско-саргатские татары",
                    "курды",
                    "курмандж",
                    "курык марий",
                    "кърым татарлар",
                    "кызыл",
                    "кызыльцы",
                    "кыпчак (с родным языком алтайским)",
                    "кыпчак (с родным языком казахским)",
                    "кыргыз",
                    "кюрегу",
                    "кюринцы",
                    "лазы",
                    "лак",
                    "лаки",
                    "лаккучу",
                    "лакцы",
                    "ламут",
                    "ламут-наматкан",
                    "лао хуйхуй",
                    "лаппи",
                    "латвиетис",
                    "латвиеши",
                    "латгальцы",
                    "латгалиетис",
                    "латыши",
                    "лезги",
                    "лезгины",
                    "лезгияр",
                    "лемки",
                    "ленские старожилы",
                    "лесные марийцы",
                    "летувис",
                    "летувник",
                    "летувяй",
                    "ливанцы",
                    "ливвикёй",
                    "ливвики",
                    "ливгиляйне",
                    "ливийцы",
                    "литвин (с родным языком белорусским)",
                    "литвин (с родным языком литовским)",
                    "литвяк (с родным языком белорусским)",
                    "литвяк (с родным языком литовским)",
                    "литовцы",
                    "лопари",
                    "лугово-восточные марийцы",
                    "луговые марийцы",
                    "луораветлан",
                    "лыгъоравэтлъан",
                    "лыгъоравэтлят",
                    "людики",
                    "людиникат",
                    "люли",
                    "лююдикёй",
                    "лююдилайне (с родным языком вепсским)",
                    "лююдилайне (с родным языком карельским)",
                    "маарулал",
                    "мавританцы",
                    "мавры",
                    "маду",
                    "мадьяр",
                    "мазанг",
                    "майминцы",
                    "малкарцы",
                    "малкъарлыла (малкъарлы)",
                    "малые дэрбэты",
                    "мамхеги",
                    "мангуны",
                    "манегры",
                    "манси",
                    "мар",
                    "маргали",
                    "мари",
                    "марий",
                    "марийцы",
                    "марийцы ветлужские",
                    "марийцы восточные (уральские)",
                    "марийцы горные",
                    "марийцы лесные",
                    "марийцы лугово-восточные",
                    "марийцы луговые",
                    "марийцы уральские (восточные)",
                    "марковцы",
                    "марокканцы",
                    "махмеги",
                    "махмеговцы",
                    "мегрелы",
                    "мегьебор",
                    "мезенцы",
                    "меннонитен",
                    "меннониты",
                    "меньдси",
                    "месхетинцы-турки",
                    "мещеряки",
                    "мижерь",
                    "мингрелы",
                    "мишари",
                    "мишэр",
                    "моансь",
                    "могади",
                    "мокша",
                    "молдаване",
                    "молдовень ",
                    "монголы",
                    "мораване",
                    "мордва",
                    "мордва-мокша",
                    "мордва-эрзя",
                    "мордвины",
                    "мордовцы",
                    "мугат",
                    "мультони",
                    "мурчен",
                    "мых абдыр",
                    "мэнэ",
                    "мюхадар",
                    "на бэйенин ",
                    "навукагмит",
                    "нагайбаки",
                    "нагайбэклэр",
                    "найман (с родным языком алтайским)",
                    "найман (с родным языком казахским)",
                    "нанай",
                    "нанайцы",
                    "нани (с родным языком нанайским)",
                    "нани (с родным языком ороч-ским)",
                    "нани (с родным языком ульч-ским)",
                    "нахада ",
                    "нганасаны",
                    "не",
                    "негды",
                    "негидальцы",
                    "немцы",
                    "немцы-меннониты",
                    "ненач",
                    "ненцы",
                    "ненэй ненэц",
                    "ненэйне",
                    "ненэчэ ",
                    "нещанг ",
                    "нибах",
                    "нивах",
                    "нивух",
                    "нивхгу",
                    "нивхи",
                    "нихондзин",
                    "ногаи крымские",
                    "ногай (с родным языком казахским)",
                    "ногай (с родным языком ногайским)",
                    "ногай-карагаш ",
                    "ногайцы ",
                    "нохчий ",
                    "нугай татар",
                    "нукратские (карийские) татары",
                    "нымыланы",
                    "нымылгын",
                    "ньигвнгун",
                    "ня",
                    "нясихагил",
                    "обские старожилы",
                    "овен",
                    "овон",
                    "одморт",
                    "одмурт ",
                    "озбак",
                    "озбек",
                    "ойраты",
                    "окморт",
                    "олёты",
                    "олык марий",
                    "олюторцы",
                    "оманцы",
                    "омоки",
                    "оре куманды",
                    "ороки (ульта)",
                    "ороч (с родным языком орочским)",
                    "ороч (с родным языком ульта)",
                    "ороч (с родным языком эвенским)",
                    "орочель",
                    "орочёл",
                    "орочён (с родным языком орочским)",
                    "орочён (с родным языком ульта)",
                    "орочён (с родным языком эвенкийским)",
                    "орочён (с родным языком эвенским)",
                    "орочи",
                    "орочисэл",
                    "орум",
                    "осетины",
                    "осетины-дигорцы",
                    "осетины-иронцы",
                    "османы",
                    "остяки (с родным языком кетским)",
                    "остяки (с родным языком мансийским) ",
                    "остяки (с родным языком селькупским)",
                    "остяки (с родным языком хантыйским)",
                    "палестинцы (с родным языком арабским) ",
                    "параба ",
                    "парс ",
                    "патаны ",
                    "пахтуны ",
                    "пашенные ",
                    "пермяки ",
                    "персы ",
                    "полуверцы ",
                    "поляки ",
                    "поляци",
                    "поморы ",
                    "поморы канинские ",
                    "понтиос",
                    "португальцы",
                    "походчане",
                    "пуштуны ",
                    "пэ-бай ",
                    "пян хасова",
                    "ром ",
                    "рома",
                    "ромеи ",
                    "ромеос",
                    "ромеюс ",
                    "ромынь",
                    "рум",
                    "румей",
                    "румыны",
                    "русины",
                    "русские",
                    "русско-устьинцы",
                    "рутул",
                    "рутульцы ",
                    "рухни рушанцы",
                    "рушони",
                    "рыхен",
                    "саами",
                    "саамы",
                    "савакот",
                    "сагай ",
                    "сагайцы",
                    "сартулы",
                    "сасигнан",
                    "саудовцы",
                    "саха (с родным языком долганским)",
                    "саха (с родным языком якутским)",
                    "сваны",
                    "селькупы",
                    "семейские",
                    "сербы",
                    "сето",
                    "сету",
                    "сибир татарлар",
                    "сибирские татары",
                    "сиренигмит",
                    "сирийцы",
                    "словаки",
                    "сойоны",
                    "сойоты (с родным языком бурятским)",
                    "сойоты (с родным языком тувинским)",
                    "селькуп",
                    "сомату",
                    "среднеазиатские арабы",
                    "среднеазиатские евреи",
                    "среднеазиатские цыгане",
                    "старожилы ленские",
                    "старожилы обские",
                    "степские казахи",
                    "суданцы",
                    "суомалайсет",
                    "суоми",
                    "сурайя",
                    "суссе кум ",
                    "сэрвы",
                    "табасаран",
                    "табасаранцы",
                    "табасараны",
                    "табын",
                    "тавгийцы",
                    "тавоктарош",
                    "тадар",
                    "тадар-кижи (с родным языком кумандинским)",
                    "тадар-кижи (с родным языком телеутским)",
                    "тадар-кижи (с родным языком хакасским)",
                    "тадар-кижи (с родным языком шорским)",
                    "таджики",
                    "тазы",
                    "талыши",
                    "талышон",
                    "тама",
                    "таланта",
                    "таранчи",
                    "тарлик",
                    "тарские татары",
                    "тат (с родным языком крым-скотатарским)",
                    "тат (с родным языком татским)",
                    "татар",
                    "татары",
                    "татары алабугатские",
                    "татары астраханские",
                    "татары заболотные",
                    "татары казанские",
                    "татары карийские (нукратские)",
                    "татары касимовские",
                    "татары крымские",
                    "татары курдакско-саргатские",
                    "татары нукратские (каринские)",
                    "татары сибирские",
                    "татары тарские",
                    "татары тевризские",
                    "татары-тептяри",
                    "татары тобольские",
                    "татары тюменско-тюринские",
                    "татары чулымские",
                    "татары юртовские ",
                    "татары ясколбинские ",
                    "татские евреи",
                    "таты-азербайджанцы",
                    "таты-иудаисты",
                    "таты-мусульмане",
                    "таулу ",
                    "тевризские татары",
                    "теленгиты",
                    "телесы",
                    "телеуты",
                    "темиргоевцы",
                    "тептяри (с родным языком башкирским) ",
                    "тептяри (с родным языком татарским) ",
                    "тептяри-башкиры ",
                    "тептяри-татары ",
                    "терюхане",
                    "тиндалы ",
                    "тиндии ",
                    "тиндинцы ",
                    "тлибишинцы ",
                    "тлиссинцы ",
                    "тоболик",
                    "тобольские ",
                    "татары ",
                    "тоджик ",
                    "тоджинцы ",
                    "томские карагасы ",
                    "тонгус ",
                    "торгоуты ",
                    "торгуты ",
                    "торкара ",
                    "тофа",
                    "тофалары ",
                    "трухмены ",
                    "туалаг ",
                    "туальцы",
                    "туба",
                    "туба-кижи ",
                    "тубалары",
                    "тубере куманды",
                    "тува ",
                    "тувинцы",
                    "тувинцы-тоджинцы",
                    "туга ",
                    "тумал ",
                    "тунгусы (с родным языком эвенкийским)",
                    "тунгусы (с родным языком эвенским) ",
                    "тунисцы ",
                    "тураминцы",
                    "туратинские казахи",
                    "тургэхал",
                    "турки",
                    "турки-батумцы",
                    "турки-месхетинцы",
                    "турки-османы",
                    "турки-сухумцы ",
                    "туркмены",
                    "туха ",
                    "тыва",
                    "тыва-кижи",
                    "тюменско-тюринские татары",
                    "тюрк (с родным языком азербайджанским)",
                    "тюрк (с родным языком турецким)",
                    "тюрк (с родным языком туркменским)",
                    "тюрк (с родным языком узбекским)",
                    "тюрки чулымские",
                    "уак",
                    "угбуган",
                    "угбуганти",
                    "уди",
                    "удины",
                    "удморт",
                    "удмурты",
                    "удэ (с родными языками китайским и русским)",
                    "удэ (с родным языком удэгейским)",
                    "удэгейцы",
                    "удэхе",
                    "удэхейцы",
                    "узбеки",
                    "уйгуры",
                    "уйльта",
                    "укморт",
                    "украинцы",
                    "ульта",
                    "ульча (с родным языком ульта)",
                    "ульча (с родным языком ульчским)",
                    "ульчи ",
                    "уназигмит",
                    "унан'ах ",
                    "унанган",
                    "уральские (восточные) марийцы",
                    "урбуган",
                    "урмей",
                    "урморт",
                    "уртморт",
                    "урум",
                    "ути",
                    "фараоны",
                    "фарс",
                    "финны",
                    "финны-ингерманландцы",
                    "франк",
                    "французы",
                    "хаас",
                    "хааш",
                    "хай",
                    "хайдаг",
                    "хакасы",
                    "халдеи",
                    "халха",
                    "халха-монголы халхасцы",
                    "хальмг",
                    "хамниганы",
                    "хамшены",
                    "хамшецы",
                    "хангайцы",
                    "хангук сарам",
                    "хандеяры",
                    "ханти",
                    "ханты",
                    "хантых",
                    "хантэ ",
                    "хань",
                    "ханьжэнь ",
                    "хванал",
                    "хваршал ",
                    "хваршинцы",
                    "хваршины",
                    "хемшилы ",
                    "хемшины ",
                    "хинатбы",
                    "хинди",
                    "хиндиязычные индийцы",
                    "хиндустанцы",
                    "хновцы",
                    "хойбал",
                    "хойты",
                    "хонгодоры",
                    "хорваты",
                    "хоринцы",
                    "хошеуты",
                    "хошуты",
                    "хуани",
                    "хугни",
                    "хуй",
                    "хуйцзу",
                    "хунзалис .",
                    "хунзалы",
                    "хунуни",
                    "хуфидж",
                    "хуфцы",
                    "хызыл",
                    "цахуры ",
                    "цезы",
                    "цонголы",
                    "цунтинцы",
                    "цыгане",
                    "цыгане среднеазиатские",
                    "чаан",
                    "чаваш",
                    "чавчу",
                    "чавчувены",
                    "чавчыв",
                    "чалканцы",
                    "чамалалы",
                    "чамалинцы",
                    "чаны",
                    "чаты",
                    "чаучу ",
                    "челканцы",
                    "черемисы",
                    "черкесогаи",
                    "черкесы",
                    "черногорцы",
                    "чехи",
                    "чеченцы",
                    "чеченцы-аккинцы",
                    "чжунго жэнь",
                    "чосон сарам",
                    "чуванцы",
                    "чуваши",
                    "чудь",
                    "чукчи",
                    "чулымские татары ",
                    "чулымские тюрки ",
                    "чулымцы ",
                    "чумыль-куп ",
                    "чуфут",
                    "чухари ",
                    "чухонцы",
                    "шалганы ",
                    "шапсуги",
                    "шапсыг ",
                    "шведы",
                    "шекты",
                    "шелькуп",
                    "шешкум",
                    "шкарауа",
                    "шкипетары",
                    "шор-кижи",
                    "шорцы",
                    "шугнанцы",
                    "шугни",
                    "шугнони",
                    "ывын",
                    "эбраэли",
                    "эбэн",
                    "эвен ",
                    "эвенк",
                    "эвенки",
                    "эвены",
                    "эвон",
                    "эвримейсет",
                    "эвын ",
                    "эвэн ",
                    "эвэс",
                    "эзды",
                    "элеты",
                    "элканбэйэ",
                    "эллинос",
                    "элутыл'у",
                    "элькан дэйнин",
                    "энцы",
                    "эньчо",
                    "энэтэ",
                    "эрзя",
                    "эскимосы",
                    "эстонцы",
                    "эстонцы-сету",
                    "эсты",
                    "этели",
                    "эуштинцы",
                    "ээсти",
                    "ээстилане",
                    "юген",
                    "юги",
                    "юкагиры",
                    "юпагыт",
                    "юпит",
                    "юртовские татары",
                    "якуты (саха)",
                    "якутяне",
                    "ямские",
                    "японцы",
                    "ясколбинские татары",
                    "яушта",
                    "яхолшу",
                    "яхуди",
                    "яхудои махали"
                ],

                countryList: [],
                countryListLoading: false,
                cityList: [],
                cityListLoading: false,
            },

            searchCountry: "",
            searchCity: "",


            rules: {
                required: value => !!value || 'Required.',
                counter: value => value.length <= 20 || 'Max 20 characters',
                minpasswd: value => (value && value.length >= 6) || 'Минимум 6 символов',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            }
        }),
        watch: {
            searchCountry: function(val) {
                var this_ = this
                if(!val){
                    this_.utility.countryList = []
                    return
                }
                if(val.length<3) return
                this.utility.countryListLoading =true

                this.$http.post('/geonames', { endpoint: 'countryInfo', q: val })
                    .then(function (response) {
                        if(response.status == 200) {
                            this_.utility.countryList = response.data.countryInfo
                            this_.utility.countryListLoading = false
                        }
                    })
            },
            searchCity: function(val) {
                var this_ = this
                if(!val){
                    this_.utility.cityList = []
                    return
                }
                if(val.length<3) return
                this.utility.cityListLoading =true

                this.$http.post('/geonames', { endpoint: 'alternates', q: val, country_code: this.agendaData.birth_country['iso_alpha2'] })
                    .then(function (response) {
                        if(response.status === 200) {
                            this_.utility.cityList = response.data.alternates
                            this_.utility.cityListLoading = false
                        }
                    })
            },

        },
        methods: {
            updateAgenda: function () {
                var this_ = this;

                this.$store.dispatch('updateAgenda', {user: {agenda: this.agendaData}}).then(function (response) {
                    this_.response = response
                    if (response.status !== 200) this_.$store.dispatch('processError', this_.response)
                    if (this_.response.status === 200) {
                        this_.$store.dispatch('processError', {status: 200, errorMessage: "Данные успешно сохранены"})
                        this_.initForm()
                        if(!this_.$store.state.user.checks.profile) this_.$router.push('/home/profile')
                        else if(!this_.$store.state.user.testcodes.length) this_.$router.push('/home/tests/reg')
                        else this_.$router.push('/')
                    }
                })
            },
            initForm: function() {
                if (this.$store.state.user.agenda) {
                    this.agendaData = JSON.parse(JSON.stringify(this.$store.state.user.agenda))
                    this.agendaDataInitial = JSON.parse(JSON.stringify(this.$store.state.user.agenda))
                    if(this.agendaData.birth_city) this.utility.cityList = [this.agendaData.birth_city]
                    if(this.agendaData.birth_country) this.utility.countryList = [this.agendaData.birth_country]
                }
            },


        },
        computed: {
            isFormDirty: function () {
                //console.log(this.agendaData.conditions, this.agendaDataInitial.conditions)
                return !jsonEqual(this.agendaData, this.agendaDataInitial)
            },
            formCanSave: function () {
                if (this.formValid && this.isFormDirty) return true;
                return false;
            }
        },
        created: function () {
            this.initForm()
        }

    }
</script>

<style type="scss" scoped>
    .v-text-field-email {
        input {
            color: red;
        }
    }
    .c-sub-title {
        min-height: 90px;
    }
    @media (max-width: 800px) {
        .c-sub-title {
            min-height: auto;
            margin-top: 30px;
        }
    }

</style>